export default __webpack_public_path__ + "static/media/right_username_icon.9e6c2134.svg";